import { createAsyncThunk } from "@reduxjs/toolkit";
import { IRolesCreate } from "../../Roles/types";
import request from "../../../../../../../service";
import { IErrorResponse } from "../../../../../../../types";
import { deletedRestoreRoleGroup, deletedRoleGroups, setRoleGroups, setRoleGroupsRestore } from "./roleGroupsSlice";
import { IEditRolesGroup, IRoleGroupsPayload } from "../types";

const CreateRoleGroups = createAsyncThunk("create/role/groups", async (data: IRolesCreate, { rejectWithValue }) => {
    try {
        const response = await request.post("/groups", data);

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const GetRoleGroups = createAsyncThunk("get/roles/groups", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get("/groups");

        dispatch(setRoleGroups(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const DeleteRoleGroups = createAsyncThunk("delete/role/groups", async (id: number, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.delete(`/groups/${id}`);

        dispatch(deletedRoleGroups(id));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const EditRoleGroups = createAsyncThunk(
    "edit/role/groups",
    async (data: IRoleGroupsPayload | IEditRolesGroup, { rejectWithValue }) => {
        try {
            const response = await request.put(`/groups/${data.id}`, data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteRoleGroups = createAsyncThunk("get/delete/role/groups", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/groups/deleted-items`);

        dispatch(setRoleGroupsRestore(response.data));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteRoleGroups = createAsyncThunk(
    "restore/delete/role/groups",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/groups/restore/${id}`);

            dispatch(deletedRestoreRoleGroup(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    CreateRoleGroups,
    GetRoleGroups,
    DeleteRoleGroups,
    EditRoleGroups,
    GetDeleteRoleGroups,
    RestoreDeleteRoleGroups,
};
